import { IStorageService } from '@dfl/react-security';
import Cookies from 'js-cookie';
import { PORTAL_ACCESS_TOKEN_KEY, PORTAL_REFRESH_TOKEN_KEY } from 'constants/index';

export class CustomStorageService implements IStorageService {
  getItem (key: string): string | undefined | null {
    return typeof window !== 'undefined' ? localStorage.getItem(key) : undefined;
  }

  setItem (key: string, value: string, options?: any) {
    localStorage.setItem(key, value);
  }

  removeItem (key: string, options?: any) {
    localStorage.removeItem(key);
  }

  clear () {
    localStorage.clear();
    Cookies.remove(PORTAL_ACCESS_TOKEN_KEY, {
      domain: process.env.REACT_APP_PORTAL_BASE_DOMAIN || 'negocioscuba.net',
    });
    Cookies.remove(PORTAL_REFRESH_TOKEN_KEY, {
      domain: process.env.REACT_APP_PORTAL_BASE_DOMAIN || 'negocioscuba.net',
    });
  }
}
